export default __webpack_public_path__ + "static/media/code-background.e6026c57.svg";